import { motion } from "framer-motion";
import { track } from "@/lib/track";

export default function MobileCTA() {
  return (
    <motion.div
      initial={{ y: 80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 1.4, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="md:hidden fixed bottom-4 inset-x-4 z-40"
      data-testid="mobile-bottom-cta-wrap"
    >
      <a
        href="#pricing"
        data-testid="mobile-bottom-cta"
        onClick={() => track("mobile_bottom_cta_click")}
        className="flex items-center justify-between gap-3 w-full px-5 py-4 rounded-full bg-[color:var(--ink)] text-[color:var(--bone)] shadow-[0_10px_40px_rgba(18,20,28,0.28)]"
      >
        <span className="font-mono text-[10px] uppercase tracking-[0.24em] text-[color:var(--copper)]">
          From $849.99
        </span>
        <span className="font-medium text-[14px]">View Passes</span>
        <span aria-hidden="true">→</span>
      </a>
    </motion.div>
  );
}
